export default "__VITE_ASSET__CvQEux88__"